import { AppQrCode } from "./AppQrCode";

export default AppQrCode;
